import React from 'react';
import TopTemplate from '../../components/template/RTCC/topTemplate';


class Top extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            // ホテル利用時間外モーダル表示用フラグ
            outsideHoursFlg: false,
            menuTitle: ""
        };
    };

    render() {

        // ホテル利用時間外モーダル表示用フラグ設定
        const setOutsideHoursFlg = (flg) => { this.setState({ outsideHoursFlg: flg }) }

        // ホテル利用時間外モーダル表示用フラグ設定
        const setMenuTitle = (menu) => { this.setState({ menuTitle: menu }) }

        return (
            <TopTemplate
                state={this.state}
                setOutsideHoursFlg={setOutsideHoursFlg}
                setMenuTitle={setMenuTitle}
            />
        )
    }
}
export default Top;